<template>
<div class="chapter">
<div class="inner_page">
<p class="space"> </p>
<p class="copyright3"><a id="page_2"></a><a id="Copyright">© 1997, 2013, by Theodore P. Savas<br/><br/>
All rights reserved. No part of this book may be reproduced or utilized in any form or by<br/>
any means, electronic or mechanical, including photocopying and recording, or by any<br/>
information storage and retrieval system, without permission in writing from the<br/>
publisher.</a></p><a id="Copyright">
<p class="copyright3"><i>Silent Hunters: German U-Boat commanders of World War II</i>, Theodore P. Savas, ed.<br/><br/>
Originally published: Campbell, California (Savas Publishing, 1997).<br/><br/>
Includes bibliographical references and index.</p>
<p class="copyright3">Digital First Edition<br/><br/>
eISBN-13: 978-1-940669-00-7</p>
<p class="space"> </p>
<p class="copyright3"><img alt="" class="image" src="images/sp.jpg"/><br/><br/>
989 Governor Drive, Suite 102<br/><br/>
El Dorado Hills, CA 95762<br/><br/>
916-941-6896 (phone)<br/><br/>
916-941-6895 (fax)</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Copyright.vue?1237ea89